import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ApplicationSubmitted.css';

const ApplicationSubmitted = () => {
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, []);
  const location = useLocation();
  const navigate = useNavigate();
  const { applicationId, email } = location.state || {};

  // If someone lands here directly with no state (e.g. via back button),
  // redirect to homepage — but never auto-redirect from a real submission
  if (!location.state) {
    return (
      <div className="as-page">
        <div className="as-card" style={{ textAlign: 'center', padding: '3rem' }}>
          <p>Nothing to show here.</p>
          <button onClick={() => navigate('/')} className="as-home-btn">Return to Homepage</button>
        </div>
      </div>
    );
  }

  const STEPS = [
    { num: '1', title: 'Application Review', desc: 'Our team will review your application and documents within 2–3 business days.' },
    { num: '2', title: 'Interview & Onboarding', desc: 'If approved, we\'ll invite you for a brief call and begin the onboarding process.' },
    { num: '3', title: 'Start Teaching & Earning!', desc: 'Once cleared, you\'ll be matched with pupils and can start earning immediately.' },
  ];

  return (
    <div className="as-page">
      <div className="as-card">

        {/* Icon */}
        <div className="as-icon">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="28" r="26" stroke="currentColor" strokeWidth="3"/>
            <path d="M17 28L24 35L39 20" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h1>Application Submitted!</h1>
        <p className="as-subtitle">Thank you for applying to join Fast Track Driving School UK.</p>

        {applicationId && (
          <div className="as-ref-box">
            <span className="as-ref-label">Application Reference</span>
            <span className="as-ref-num">{applicationId}</span>
          </div>
        )}

        {email && (
          <>
            <p className="as-email-note">A confirmation email has been sent to <strong>{email}</strong></p>
            <p className="as-email-note" style={{ fontSize: '0.82rem', color: '#94a3b8', marginTop: '0.25rem' }}>📬 Can't find it? Check your <strong>spam or junk folder</strong>.</p>
          </>
        )}

        {/* Next Steps */}
        <div className="as-steps">
          <h2>What Happens Next?</h2>
          <div className="as-timeline">
            {STEPS.map(s => (
              <div className="as-timeline-item" key={s.num}>
                <div className="as-timeline-marker">{s.num}</div>
                <div className="as-timeline-body">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="as-contact">
          <p>Questions? Contact our recruitment team:</p>
          <div className="as-contact-methods">
            <a href="mailto:contact@fasttrackds.co.uk" className="as-contact-link">📧 contact@fasttrackds.co.uk</a>
          </div>
        </div>

        <button onClick={() => navigate('/')} className="as-home-btn">Return to Homepage</button>
      </div>
    </div>
  );

};

export default ApplicationSubmitted;
